<template>
  <div id="invitation">
    <van-row>
      <van-col span="24" class="invitation_withdrawal">
        <van-col span="24" class="invitation_withdrawal_bg">
          <van-col span="24" class="invitation_withdrawal_name">{{ $t('column.withdrawal_amount')}}</van-col>
          <van-col span="24" class="invitation_withdrawal_money">
            <van-col span="2">$</van-col>
            <van-col span="22">
              <van-field v-model="number" type="number" :placeholder="$t('placeholder.Input_withdrawal_amount')" />
            </van-col>
          </van-col>
          <van-col span="24" class="invitation_withdrawal_money_sum">
            <van-col span="18" class="invitation_withdrawal_money_sum_val">{{ $t('column.can_withdrawal_amount')}} $ {{ user.invitation_coin }}</van-col>
            <van-col span="6" class="invitation_withdrawal_money_sum_btn" @click="number = user.invitation_coin">{{ $t('column.full_withdrawal')}}</van-col>
          </van-col>
        </van-col>
        <van-col span="24" class="invitation_withdrawal_pay" @click="pay_binding()">
          <van-col span="4" class="invitation_withdrawal_pay_img">
            <img src="./../assets/img/zhifubao.png"/>
          </van-col>
          <van-col span="10" class="invitation_withdrawal_pay_name">{{ $t('column.cash_to_alipay')}}</van-col>
          <van-col span="10">
            <van-col span="20" class="invitation_withdrawal_pay_right_val">{{ user.alipay_account }}</van-col>
            <van-col span="4" class="invitation_withdrawal_pay_right_icon"><van-icon name="arrow" /></van-col>
          </van-col>
        </van-col>
        <van-col span="18" offset="3" class="invitation_withdrawal_pay_btn" @click="invitation_pay_btn()">{{ $t('btn.confirm')}}</van-col>
        <van-col span="24" class="iphonex_bottom"></van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  export default {
    data() {
      return {
        user: {},
        number: ''
      }
    },
    created: function() {
      this.convert()
      document.title = this.$t('title.invitation')
    },
    methods: {
      convert: function() {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=withdrawal", {
          params : {
            token: token
          }
        }).then(res =>{
          console.log(res.data)
          this.user = res.data.data
          if (res.data.status === 0) {
            Toast(res.data.error)
            return false
          }
        })
      },
      invitation_pay_btn () {
        if (this.number <= 0) {
          Toast(this.$t('Tips.Input_withdrawal_amount'))
          return false
        }

        if (parseInt(this.number) > parseInt(this.user.invitation_coin)) {
          Toast(this.$t('Tips.Incorrect_withdrawal_amount'))
          return false
        }

        if (!this.user.alipay_account) {
          Toast(this.$t('Tips.bind_alipay_account'))
          return false
        }
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=withdrawal_add", {
          params : {
            token: token,
            coin: this.number
          }
        }).then(res =>{
          console.log(res.data)
          Toast(res.data.error)
          if (res.data.status === 1) {
            this.number = ''
            this.convert()
          }

        })
      },
      pay_binding () {
        const token = this.$route.query.token
        this.$router.push({path:'/invitationPinless',query:{token: token }});
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/invitation_withdrawal.vue